import _ from 'lodash';

import { getUUID } from 'utils/uuid';

import {
  CONTEXT_SEPARATOR,
  MERS_CHANNEL_LABELS,
  MERS_PREVIEW_TITLE_PREFIX,
  MERS_PREVIEW_VERDICT_CONFIGS,
  MersPreviewVerdict,
  ORG_ID_PREFIX,
  UNKNOWN_VERDICT_CONFIG,
  WOULD_SEND_WITHOUT_PAYLOAD_TITLE,
} from './MersPreviewDrawer.constants';

// "Preview — MERS registration" from the "Registration" | "Transfer" | "Deactivation" operation.
export const getMersPreviewTitle = operation =>
  operation ? `${MERS_PREVIEW_TITLE_PREFIX} ${_.toLower(operation)}` : MERS_PREVIEW_TITLE_PREFIX;

// "Production · XML · Org ID 1234567" — the parts the backend could tell; null when it could tell none.
export const getMersPreviewContextLine = ({ environment, channel, orgId }) => {
  const parts = [
    _.upperFirst(environment ?? ''),
    MERS_CHANNEL_LABELS[channel] ?? channel ?? '',
    orgId ? `${ORG_ID_PREFIX} ${orgId}` : '',
  ].filter(Boolean);

  return parts.length ? parts.join(CONTEXT_SEPARATOR) : null;
};

export const getMersPreviewVerdictConfig = (verdict, hasPayload) => {
  const config = MERS_PREVIEW_VERDICT_CONFIGS[verdict] ?? UNKNOWN_VERDICT_CONFIG;

  return verdict === MersPreviewVerdict.WOULD_SEND && !hasPayload
    ? { ...config, title: WOULD_SEND_WITHOUT_PAYLOAD_TITLE }
    : config;
};

// Fields keep the backend's order, so a row's position is its id.
export const getMersPreviewFieldRows = fields =>
  fields.map((field, index) => ({ ...field, id: `row-${index}` }));

// Each preview gets its own key, so a new run's payload section starts collapsed (or open, with no payload) again.
export const getMersPreviewRunKey = preview => (preview ? getUUID() : null);

// Errors can repeat, so each gets its own key.
// A problem the message already states (the backend often repeats its one reason in both) is not listed again.
export const getMersPreviewErrorItems = (errors, message = '') =>
  errors.filter(text => !(message ?? '').includes(text)).map(text => ({ id: getUUID(), text }));
